import { defineMessages } from 'react-intl';

export default defineMessages({
    discounts: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.Discounts',
        defaultMessage: 'Discounts'
    },
    dateCannotBePriorYearBuilt: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.Date entered cannot be prior to Year Built',
        defaultMessage: '{nameOfModifier}: Date entered cannot be prior to Year Built'
    },
    importantReminder: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.Important Reminder',
        defaultMessage: 'Important Reminder'
    },
    confirmEmailAddress: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.confirmEmailAddress',
        defaultMessage: 'Customer will receive email to validate Smart Home device at {email}. Confirm email address on Profile Details page.'
    },
    warningMessage: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.warningMessage',
        defaultMessage: '{importantReminder} {confirmEmailAddress}'
    },
    nextDescription: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.nextDescription',
        defaultMessage: 'We\'ll need some {additionalInformation} next'
    },
    additionalInformation: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.additional information',
        defaultMessage: 'additional information'
    },
    somethingWentWrong: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.somethingWentWrong',
        defaultMessage: 'Something went wrong during this process. Please try again.'
    },
    dateCannotBeAfterTodaysDate: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.Date entered cannot be after todays date',
        defaultMessage: '{nameOfModifier}: Date entered cannot be after today\'s date'
    },
    disclosure: {
        id: 'ml.agent.quoteandbind.ho.AdditionalDiscounts.disclosure information',
        defaultMessage: 'claim information'
    },
    tenantScreeningTooltip: {
        id: 'ml.agent.quoteandbind.ho.AdditionalDiscounts.tenantScreening Tooltip',
        defaultMessage:
            '<b>Credit check:</b> The landlord orders and reviews the tenant\'s credit report history.<br></br>' +
            '<br></br><b>Criminal background check:</b> The landlord orders a report the tenant\'s criminal record including prior convictions.<br></br>' +
            '<br></br><b>Eviction search:</b> The landlord orders a report of the prior tenant evictions.<br></br>' +
            '<br></br><b>HO4 tenant policy on file:</b> The landlord maintains a copy of the tenant\'s HO4 policy.<br></br>' +
            '<br></br><b>Skip search:</b> The landlord orders a report of the tenant\'s prior unfulfilled lease agreements.'
    },
    inValidOptionselected: {
        id: 'ml.agent.quoteandbind.ho.AdditionalDiscounts.Invalid Option selected',
        defaultMessage: '“None apply” cannot be selected with other options. Please update your selections.'
    },
    requiredDetailsMissingError: {
        id: 'ml.agent.quoteandbind.ho.AdditionalDiscounts.requiredDetailsMissingError',
        defaultMessage: 'Please provide all the required details'
    },
    defensibleSpaceLabel: {
        id: 'ml.quoteandbind.ho.AdditionalDiscounts.Defensible Space',
        defaultMessage: 'Defensible Space'
    },
    defensibleSpaceUnavailableLabel: {
        id: `ml.quoteandbind.ho.AdditionalDiscounts.Defensible Space data is not available for this property`,
        defaultMessage: `Defensible Space data is not available for this property`
    },
    tenantValueRequired: {
        id: `ml.quoteandbind.ho.AdditionalDiscounts.TenantScreeningError`,
        defaultMessage: `Please provide the required information for the Tenant Screenings`
    }
});
